var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "records-list"
  }, [_vm.filterByDate ? _c('div', {
    staticClass: "d-flex s-p-3 bg-white\n        justify-content-between\n        align-items-center\n      "
  }, [_vm.filterByDate && _vm.filterByDate.show_calendar && !_vm.filterByDate.show_option ? [_c('datepicker', {
    staticClass: "p-0 field__input mr-3",
    attrs: {
      "placeholder": "請輸入查詢開始時間",
      "value": _vm.startAt,
      "bootstrap-styling": "",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "input-class": "px-3 text-center",
      "disabled-dates": _vm.disabledDates,
      "popover-align": "center"
    },
    on: {
      "input": function input(e) {
        _vm.startAt = _vm.fixDate(e);
      },
      "selected": _vm.dateStartChange
    }
  }), _c('div', {
    staticClass: "mr-3"
  }, [_vm._v("─")])] : _vm._e(), _vm.filterByDate && _vm.filterByDate.show_calendar ? [_c('datepicker', {
    staticClass: "p-0 field__input",
    class: _vm.filterByDate.show_option ? 'mr-3' : '',
    attrs: {
      "placeholder": "請輸入查詢結束時間",
      "value": _vm.endAt,
      "bootstrap-styling": "",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "input-class": "px-3 text-center",
      "position": "center",
      "disabled-dates": _vm.disabledDates
    },
    on: {
      "input": function input(e) {
        _vm.endAt = _vm.fixDate(e);
      },
      "selected": _vm.dateEndChange
    }
  })] : _vm._e(), _vm.filterByDate && _vm.filterByDate.show_option ? _c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.daysDiff
    },
    on: {
      "change": _vm.dateOptionChange
    }
  }, _vm._l(_vm.filterByDate.options, function (i) {
    return _c('option', {
      key: i.key,
      domProps: {
        "value": i.key
      }
    }, [_vm._v(" " + _vm._s(i.title) + " ")]);
  }), 0) : _vm._e()], 2) : _vm._e(), _vm._l(_vm.pointLogs, function (item) {
    return _c('PointCard', {
      key: item.id,
      attrs: {
        "title": item.name,
        "date": item.date,
        "date-label": '交易日期',
        "type-text": item.type_text,
        "point-need-text": item.point_need_text
      }
    });
  }), _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }